import React from "react";
import { Input, TextArea, FormButton } from "./";

export default class ContactForm extends React.Component {
  render() {
    const { person, handleFormSubmit, handleInputChange, inputTheme, buttonTheme } = this.props;
    return (
      <form onSubmit={handleFormSubmit}>
          <Input
            type="text"
            name="fullname"          
            value={person.fullname}
            placeholder="Tell us your full name"
            label="Full name"
            handleInputChange={handleInputChange}
            theme={inputTheme}
            required
          />
          <Input
            type="email"
            name="from"          
            value={person.from}
            placeholder="What's your email address?"
            label="Email"
            handleInputChange={handleInputChange}
            theme={inputTheme}
            required
          />
          <Input
            type="text"
            name="country"          
            value={person.country}
            placeholder="Tell us your country"
            label="Country"
            handleInputChange={handleInputChange}
            theme={inputTheme}
          />
          <Input
            type="text"
            name="subject"          
            value={person.subject}
            placeholder="Subject"
            label="Subject"
            handleInputChange={handleInputChange}
            theme={inputTheme}
          />
          <TextArea
            name="message"          
            value={person.message}
            placeholder="Message"
            rows={6}
            width="400px"
            handleInputChange={handleInputChange}
            theme={inputTheme}
          />
          <FormButton
            type="submit"  
            value="Submit"
            theme={buttonTheme}
          />
        </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/FormElements/ContactForm.js